<template>
    <div>
        <svg xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" version="1.1" x="0px" y="0px" width="485.6px" height="180.6px" viewBox="0 0 485.6 180.6" style="enable-background:new 0 0 485.6 180.6;"
            xml:space="preserve" id="svg190" sodipodi:docname="pantalla 6-3.svg" inkscape:version="0.92.5 (2060ec1f9f, 2020-04-08)">
                    <metadata id="metadata196">
                        <rdf:RDF>
                            <cc:Work rdf:about="">
                                <dc:format>image/svg+xml</dc:format>
                                <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
                            </cc:Work>
                        </rdf:RDF>
                    </metadata>
                    <defs id="defs194">
                        <linearGradient id="XMLID_509_" gradientUnits="userSpaceOnUse" x1="349.4805" y1="72.440399"
                            x2="473.30469" y2="72.440399">
                            <stop offset="0" style="stop-color:#23CAD9" id="stop167" />
                            <stop offset="0.9898" style="stop-color:#32ADF0" id="stop169" />
                        </linearGradient>
                        <linearGradient id="XMLID_423_" x1="13" x2="13" y1="-2.4879999" y2="28.556999"
                            gradientUnits="userSpaceOnUse" gradientTransform="translate(107.59869,10.140594)">
                            <stop offset="0" stop-color="#54d354" id="stop4" />
                            <stop offset="1" stop-color="#119552" id="stop6" />
                        </linearGradient>
                        <linearGradient id="XMLID_423_-3" x1="13" x2="13" y1="-2.4879999" y2="28.556999"
                            gradientUnits="userSpaceOnUse" gradientTransform="translate(276.67724,10.140594)">
                            <stop offset="0" stop-color="#54d354" id="stop4-6" />
                            <stop offset="1" stop-color="#119552" id="stop6-7" />
                        </linearGradient>
                        <linearGradient id="XMLID_423_-1" x1="13" x2="13" y1="-2.4879999" y2="28.556999"
                            gradientUnits="userSpaceOnUse" gradientTransform="translate(447.35843,10.140594)">
                            <stop offset="0" stop-color="#54d354" id="stop4-2" />
                            <stop offset="1" stop-color="#119552" id="stop6-70" />
                        </linearGradient>
                        <linearGradient id="linearGradient839" x1="13" x2="13" y1="-2.4879999" y2="28.556999"
                            gradientUnits="userSpaceOnUse">
                            <stop offset="0" stop-color="#54d354" id="stop835" />
                            <stop offset="1" stop-color="#119552" id="stop837" />
                        </linearGradient>
                        <linearGradient id="linearGradient1014" x1="13" x2="13" y1="-2.4879999" y2="28.556999"
                            gradientUnits="userSpaceOnUse">
                            <stop offset="0" stop-color="#54d354" id="stop835-5" />
                            <stop offset="1" stop-color="#119552" id="stop837-6" />
                        </linearGradient>
                        <linearGradient id="linearGradient1039" x1="13" x2="13" y1="-2.4879999" y2="28.556999"
                            gradientUnits="userSpaceOnUse">
                            <stop offset="0" stop-color="#54d354" id="stop835-0" />
                            <stop offset="1" stop-color="#119552" id="stop837-62" />
                        </linearGradient>
                    </defs>
                    <sodipodi:namedview pagecolor="#ffffff" bordercolor="#666666" borderopacity="1" objecttolerance="10"
                        gridtolerance="10" guidetolerance="10" inkscape:pageopacity="0" inkscape:pageshadow="2"
                        inkscape:window-width="1920" inkscape:window-height="1016" id="namedview192" showgrid="false"
                        inkscape:zoom="2.4958813" inkscape:cx="269.83063" inkscape:cy="56.148928" inkscape:window-x="0"
                        inkscape:window-y="27" inkscape:window-maximized="1" inkscape:current-layer="svg190" />
        
                    <g id="boton1" inkscape:label="#g1388" @click="evaluar(1)">
                        <g id="XMLID_1158_">
                            <rect style="fill:none" height="16.5" width="52" class="st241" y="151.10001" x="48.200001"
                                id="XMLID_1260_" />
                            <text style="font-size:17px;font-family:FontBase-SemiBold;fill:#2d2d2d" id="text11"
                                class="st128 st110 st284" transform="translate(58.0039,163.0947)">TWA</text>
        
        
                        </g>
                        <g id="XMLID_694_">
                            <g id="XMLID_689_">
                                <circle style="fill:#ffeb99" r="59.400002" cy="72.400002" cx="74.199997" class="st191"
                                    id="XMLID_1220_" />
                                <g id="XMLID_1193_">
                                    <defs id="defs16">
                                        <circle r="59.400002" cy="72.400002" cx="74.199997" id="XMLID_1166_" />
                                    </defs>
                                    <clipPath id="XMLID_463_">
                                        <use height="100%" width="100%" y="0" x="0" id="use18" style="overflow:visible"
                                            xlink:href="#XMLID_1166_" />
                                    </clipPath>
                                    <g clip-path="url(#XMLID_463_)" id="XMLID_1157_">
                                        <g id="XMLID_1159_">
                                            <path style="fill:#004263" inkscape:connector-curvature="0"
                                                d="m 52.9,88.5 c 0,0 -3.9,80.2 -1.4,82.7 2.4,2.5 45.3,-5.3 45.3,-5.3 0,0 -2.8,-68.9 -3.7,-77.4 L 74,83 c 0,0 -17.4,5.4 -21.1,5.5 z"
                                                class="st267" id="XMLID_1219_" />
                                            <path style="fill:#bb8062" inkscape:connector-curvature="0"
                                                d="M 81.3,88.5 80.8,71 c -4.7,-1.3 -9.5,-1.2 -14.1,0.1 -0.2,4 -0.4,8 -0.6,12 0,0.5 0,4.9 0,5.4 l 7.7,7.5 z"
                                                class="st66" id="XMLID_1218_" />
                                            <path style="fill:#d0d0d0" inkscape:connector-curvature="0"
                                                d="M 79.9,90.2 73.7,104.5 68,89.1 c 0.1,0 4.9,4.1 11.9,1.1 z" class="st274"
                                                id="XMLID_1216_" />
                                            <g id="XMLID_1206_">
                                                <g id="XMLID_1207_">
                                                    <path style="fill:#004263" inkscape:connector-curvature="0"
                                                        d="M 32.8,176.7 C 27.7,98.9 51.9,89.3 52.9,88.5 l 6.3,8.5 v 0 c 0,0 -5,4.2 -9.4,14.6 -4.1,9.7 -9.2,37.3 -6.8,64.2 z"
                                                        class="st267" id="XMLID_1209_" />
                                                </g>
                                            </g>
                                            <g id="XMLID_1202_">
                                                <g id="XMLID_1203_">
                                                    <g id="XMLID_1204_">
                                                        <path style="fill:#004263" inkscape:connector-curvature="0"
                                                            d="M 113.1,177.7 C 116.8,91.6 94,89.3 93,88.5 L 86.7,97 v 0 c 0,0 5,4.2 9.4,14.6 4.1,9.7 9.2,38.3 6.8,65.2 z"
                                                            class="st267" id="XMLID_1205_" />
                                                    </g>
                                                </g>
                                            </g>
                                            <polygon style="fill:#006384" points="72.5,85.3 68.8,95 63.7,88.6 65.6,80.9 "
                                                class="st268" id="XMLID_1201_" />
                                            <polygon style="fill:#006384" points="79.7,94.4 77.3,84.8 82,81.5 85,88.2 "
                                                class="st268" id="XMLID_1200_" />
                                            <polygon style="fill:#006384" points="68.2,112.6 57.5,112.9 58.4,127.3 68.2,127.3 "
                                                class="st268" id="XMLID_1198_" />
                                            <polygon style="fill:#006384" points="79.6,112.6 90.5,112.9 89.5,127.3 79.6,127.3 "
                                                class="st268" id="XMLID_1197_" />
                                            <polygon style="fill:#003449" points="62.8,116.1 57.5,112.9 68.2,112.6 "
                                                class="st266" id="XMLID_1196_" />
                                            <polygon style="fill:#003449" points="85.3,116.4 79.6,112.6 90.5,112.9 "
                                                class="st266" id="XMLID_1195_" />
                                            <g id="XMLID_1188_">
                                                <circle style="fill:#2b2b2b" r="0.89999998" cy="154.89999" cx="73.400002"
                                                    class="st109" id="XMLID_1192_" />
                                                <circle style="fill:#2b2b2b" r="0.89999998" cy="144.2" cx="73.099998"
                                                    class="st109" id="XMLID_1191_" />
                                                <circle style="fill:#2b2b2b" r="0.89999998" cy="133.5" cx="72.900002"
                                                    class="st109" id="XMLID_1190_" />
                                                <circle style="fill:#2b2b2b" r="0.89999998" cy="122.8" cx="72.599998"
                                                    class="st109" id="XMLID_1189_" />
                                            </g>
                                            <path style="fill:#d29472" inkscape:connector-curvature="0"
                                                d="m 90.3,57.7 c 0.7,-1.5 2.5,-1.6 3.1,-0.3 0.7,1.3 0.3,3.4 -0.7,4.7 -1,1.3 -2.3,1.7 -3.5,1.5"
                                                class="st277" id="XMLID_1187_" />
                                            <path style="fill:#d29472" inkscape:connector-curvature="0"
                                                d="m 77.6,82.9 c -4,0.3 -4.3,-0.4 -5.1,-0.8 C 71.3,81.5 61.7,76 60.7,71.8 59,64.7 59.2,58.3 59.1,51 c -0.1,-5.1 0,-10.7 2.7,-14.7 3.3,-5 9.2,-6 14.5,-6.3 2.5,-0.2 6.4,0.2 9.1,2 2.2,1.4 4.7,7.6 4.7,9.6 0.2,12.3 -0.9,16.1 -2.6,28.3 -0.8,5.5 -8.9,12.9 -9.9,13"
                                                class="st277" id="XMLID_1186_" />
                                            <path style="fill:#bb8062" inkscape:connector-curvature="0"
                                                d="m 74.7,54.4 c 4.1,-7.4 -6.1,-10.2 -7.3,0 0,0 0.8,1.1 3.4,1.1 2.6,0 3.9,-1.1 3.9,-1.1 z"
                                                class="st66" id="XMLID_1185_" />
                                            <path style="fill:#bb8062" inkscape:connector-curvature="0"
                                                d="m 88.1,54.4 c 4.1,-7.4 -6.1,-10.2 -7.3,0 0,0 0.8,10.2 0.8,10.7 0.4,2.6 6.5,-10.7 6.5,-10.7 z"
                                                class="st66" id="XMLID_1184_" />
                                            <path style="fill:#bb8062" inkscape:connector-curvature="0"
                                                d="m 59.6,58.1 c -0.5,-1.8 -2.4,-2.6 -3.8,-1.8 -1.4,0.8 -2.2,2.8 -1.9,4.7 0.2,1.9 1.3,3.5 2.6,4.4 0.8,0.6 1.7,0.9 2.6,0.7 0.9,-0.2 1.7,-1.2 1.7,-2.3"
                                                class="st66" id="XMLID_1183_" />
                                            <g id="XMLID_1181_">
                                                <path style="fill:#56361a" inkscape:connector-curvature="0"
                                                    d="m 80.7,53.6 c 0.2,1.8 0.4,3.6 0.7,5.4 0.2,1.8 0.5,3.6 0.5,5.4 0,0.5 0,0.9 -0.1,1.4 -0.1,0.5 -0.3,0.9 -0.7,1.3 -0.7,0.6 -1.7,0.8 -2.6,0.8 -0.9,0 -1.8,-0.2 -2.7,-0.5 C 75.4,67.2 75,67 74.6,66.7 74.3,66.4 74,66 74,65.5 c 0,0.5 0.3,0.8 0.7,1.1 0.4,0.3 0.8,0.5 1.2,0.6 0.8,0.3 1.7,0.4 2.6,0.4 0.9,0 1.8,-0.2 2.4,-0.8 0.3,-0.3 0.5,-0.7 0.6,-1.1 0.1,-0.4 0,-0.9 0.1,-1.3 0,-1.8 -0.2,-3.6 -0.4,-5.4 l -0.3,-2.7 c -0.1,-0.9 -0.2,-1.8 -0.2,-2.7 z"
                                                    class="st63" id="XMLID_1182_" />
                                            </g>
                                            <path style="fill:#2b2b2b" inkscape:connector-curvature="0"
                                                d="m 67.4,49.7 c 1.5,-2.4 6.8,-3.3 8.4,-1.1 0.2,0.3 -3.4,-0.8 -8.4,1.1"
                                                class="st109" id="XMLID_1180_" />
                                            <path style="fill:#2b2b2b" inkscape:connector-curvature="0"
                                                d="m 88.5,49.4 c 1.3,1.1 -0.8,-2.7 -3.2,-2.2 -1.3,0.3 -2.6,0.6 -3.2,2.3 0,0.1 3.2,-2.8 6.4,-0.1 z"
                                                class="st109" id="XMLID_1179_" />
                                            <path style="fill:#ffffff" inkscape:connector-curvature="0"
                                                d="m 69.6,72.1 c 1.1,1.1 3.8,2.7 5.6,2.6 1.8,-0.1 3.5,-0.9 4.6,-2.1"
                                                class="st193" id="XMLID_1178_" />
                                            <g id="XMLID_1176_">
                                                <path style="fill:#2b2b2b" inkscape:connector-curvature="0"
                                                    d="m 74.7,54.4 c -0.5,-0.5 -1.1,-0.6 -1.8,-0.7 -0.6,-0.1 -1.2,-0.2 -1.8,-0.2 -0.6,0 -1.2,0.1 -1.8,0.2 -0.6,0.1 -1.2,0.4 -1.9,0.7 0.3,-0.7 0.8,-1.3 1.5,-1.7 0.7,-0.4 1.4,-0.6 2.2,-0.6 0.8,0 1.5,0.2 2.2,0.5 0.3,0.2 0.7,0.4 0.9,0.7 0.3,0.4 0.5,0.8 0.5,1.1 z"
                                                    class="st109" id="XMLID_1177_" />
                                            </g>
                                            <path style="fill:#ffffff" inkscape:connector-curvature="0"
                                                d="m 67.6,54.6 h 6.8 c 0.2,-0.1 0.3,-0.2 0.3,-0.2 -0.5,-1.4 -5,-2.6 -7.3,0 0,0 0.1,0.1 0.2,0.2 z"
                                                class="st193" id="XMLID_1175_" />
                                            <path style="fill:#2b2b2b" inkscape:connector-curvature="0"
                                                d="m 72.3,54.6 c 0.1,-0.2 0.1,-0.4 0.1,-0.6 0,-0.8 -0.7,-1.4 -1.5,-1.4 -0.8,0 -1.5,0.6 -1.5,1.4 0,0.2 0.1,0.4 0.1,0.6 z"
                                                class="st109" id="XMLID_1174_" />
                                            <ellipse style="fill:#ffffff" ry="0.5" rx="0.60000002" cy="53.700001" cx="72.300003"
                                                class="st193" id="XMLID_1173_" />
                                            <g id="XMLID_1171_">
                                                <path style="fill:#2b2b2b" inkscape:connector-curvature="0"
                                                    d="m 87.7,54.4 c -0.5,-0.4 -1,-0.6 -1.5,-0.7 -0.5,-0.1 -1,-0.2 -1.5,-0.2 -0.5,0 -1,0.1 -1.5,0.2 -0.5,0.1 -1,0.4 -1.6,0.7 0.1,-0.6 0.5,-1.2 1.1,-1.6 0.6,-0.4 1.3,-0.6 2,-0.6 0.7,0 1.4,0.2 2,0.6 0.1,0.1 0.3,0.2 0.4,0.3 0.1,0.1 0.2,0.3 0.3,0.4 0.2,0.3 0.4,0.6 0.3,0.9 z"
                                                    class="st109" id="XMLID_1172_" />
                                            </g>
                                            <path style="fill:#ffffff" inkscape:connector-curvature="0"
                                                d="m 81.8,54.6 h 5.7 c 0.1,-0.1 0.2,-0.2 0.2,-0.2 -0.4,-1.4 -4.1,-2.6 -6.1,0 0,0 0.1,0.1 0.2,0.2 z"
                                                class="st193" id="XMLID_1168_" />
                                            <path style="fill:#2b2b2b" inkscape:connector-curvature="0"
                                                d="m 85.7,54.6 c 0.1,-0.2 0.1,-0.4 0.1,-0.6 0,-0.8 -0.6,-1.4 -1.3,-1.4 -0.7,0 -1.3,0.6 -1.3,1.4 0,0.2 0,0.4 0.1,0.6 z"
                                                class="st109" id="XMLID_1167_" />
                                            <ellipse style="fill:#ffffff" ry="0.5" rx="0.60000002" cy="53.700001" cx="85.699997"
                                                class="st193" id="XMLID_1165_" />
                                            <path style="fill:#ffffff" inkscape:connector-curvature="0"
                                                d="m 93.3,42.4 c 0,0 -1.7,-14.3 -6.4,-16.6 l -0.6,-2.9 c 0,0 -11.5,-2.6 -22.4,2.4 -10.9,5 -8.4,20.6 -8.4,20.6 z"
                                                class="st193" id="XMLID_1163_" />
                                            <polygon style="fill:#d0d0d0" points="55.8,47.2 93.7,44.4 94.2,41.1 55.1,45 "
                                                class="st274" id="XMLID_1161_" />
                                            <path style="fill:#2b2b2b" inkscape:connector-curvature="0"
                                                d="m 59.7,47 c 0,0 -1.2,30.1 11.8,34.6 0,0 -11.1,-6.2 -8.6,-34.8 z"
                                                class="st109" id="XMLID_1160_" />
                                        </g>
                                    </g>
                                </g>
                                <linearGradient y2="72.440399" x2="136.09959" y1="72.440399" x1="12.2754"
                                    gradientUnits="userSpaceOnUse" id="XMLID_464_">
                                    <stop id="stop68" style="stop-color:#23CAD9" offset="0" />
                                    <stop id="stop70" style="stop-color:#32ADF0" offset="0.9898" />
                                </linearGradient>
        
                                <circle r="59.400002" cy="72.400002" cx="74.199997"
                                    style="fill:none;stroke:url(#XMLID_464_);stroke-width:5;stroke-miterlimit:10"
                                    id="XMLID_1164_" />
                            </g>
                            <g id="XMLID_1208_">
                                <rect style="fill:#93adad" height="4.8000002" width="8.3000002" class="st104" y="88.099998"
                                    x="104.7" id="XMLID_1194_" />
                                <rect style="fill:#f9385d" height="6.3000002" width="20.5" class="st92" y="81.800003"
                                    x="98.599998" id="XMLID_1199_" />
                                <circle style="fill:#23cad9" r="24.700001" cy="116" cx="108.9" class="st72" id="XMLID_1169_" />
                                <circle style="fill:#ffffff" r="18.6" cy="116" cx="108.9" class="st193" id="XMLID_1170_" />
                                <path style="fill:#ff3bcc" inkscape:connector-curvature="0"
                                    d="m 125.1,116 c 0,9 -7.3,16.2 -16.2,16.2 -6.7,0 -12.4,-4 -14.9,-9.8 L 108.9,116 V 99.7 c 8.9,0 16.2,7.3 16.2,16.3 z"
                                    class="st158" id="XMLID_1211_" />
                                <circle style="fill:#042ab2" r="2.3" cy="116" cx="108.9" class="st278" id="XMLID_1210_" />
                                <line style="fill:none;stroke:#042ab2;stroke-width:2;stroke-miterlimit:10" y2="116" x2="108.9"
                                    y1="119.9" x1="99.800003" class="st271" id="XMLID_1212_" />
                                <line style="fill:none;stroke:#042ab2;stroke-width:2;stroke-miterlimit:10" y2="100.8" x2="108.9"
                                    y1="116" x1="108.9" class="st271" id="XMLID_1214_" />
                            </g>
                        </g>
                    </g>
                    <g id="boton2" inkscape:label="#g1460" @click="evaluar(2)">
                        <g id="XMLID_1223_">
                            <rect style="fill:none" height="16.5" width="52" class="st241" y="151.10001" x="216.8"
                                id="XMLID_1329_" />
                            <text style="font-size:17px;font-family:FontBase-SemiBold;fill:#2d2d2d" id="text87"
                                class="st128 st110 st284" transform="translate(224.6768,163.0947)">STEL</text>
        
        
                        </g>
                        <g id="XMLID_696_">
                            <g id="XMLID_686_">
                                <circle style="fill:#ffc892" r="59.400002" cy="72.400002" cx="242.8" class="st189"
                                    id="XMLID_1316_" />
                                <g id="XMLID_1267_">
                                    <defs id="defs92">
                                        <circle r="59.400002" cy="72.400002" cx="242.8" id="XMLID_1269_" />
                                    </defs>
                                    <clipPath id="XMLID_496_">
                                        <use height="100%" width="100%" y="0" x="0" id="use94" style="overflow:visible"
                                            xlink:href="#XMLID_1269_" />
                                    </clipPath>
                                    <g clip-path="url(#XMLID_496_)" id="XMLID_1270_">
                                        <g id="XMLID_1271_">
                                            <path style="fill:#004263" inkscape:connector-curvature="0"
                                                d="m 221.5,88.5 c 0,0 -3.9,80.2 -1.4,82.7 2.4,2.5 45.3,-5.3 45.3,-5.3 0,0 -2.8,-68.9 -3.7,-77.4 L 242.6,83 c 0,0 -17.4,5.4 -21.1,5.5 z"
                                                class="st267" id="XMLID_1315_" />
                                            <path style="fill:#bb8062" inkscape:connector-curvature="0"
                                                d="M 249.9,88.5 249.4,71 c -4.7,-1.3 -9.5,-1.2 -14.1,0.1 -0.2,4 -0.4,8 -0.6,12 0,0.5 0,4.9 0,5.4 l 7.7,7.5 z"
                                                class="st66" id="XMLID_1314_" />
                                            <path style="fill:#d0d0d0" inkscape:connector-curvature="0"
                                                d="m 248.5,90.2 -6.2,14.3 -5.7,-15.4 c 0.1,0 4.9,4.1 11.9,1.1 z" class="st274"
                                                id="XMLID_1313_" />
                                            <g id="XMLID_1310_">
                                                <g id="XMLID_1311_">
                                                    <path style="fill:#004263" inkscape:connector-curvature="0"
                                                        d="m 201.4,176.7 c -5.1,-77.8 19.1,-87.4 20.1,-88.2 l 6.3,8.5 v 0 c 0,0 -5,4.2 -9.4,14.6 -4.1,9.7 -9.2,37.3 -6.8,64.2 z"
                                                        class="st267" id="XMLID_1312_" />
                                                </g>
                                            </g>
                                            <g id="XMLID_1306_">
                                                <g id="XMLID_1307_">
                                                    <g id="XMLID_1308_">
                                                        <path style="fill:#004263" inkscape:connector-curvature="0"
                                                            d="M 281.8,177.7 C 285.4,91.6 262.7,89.3 261.7,88.5 l -6.3,8.5 v 0 c 0,0 5,4.2 9.4,14.6 4.1,9.7 9.2,38.3 6.8,65.2 z"
                                                            class="st267" id="XMLID_1309_" />
                                                    </g>
                                                </g>
                                            </g>
                                            <polygon style="fill:#006384" points="241.1,85.3 237.4,95 232.3,88.6 234.2,80.9 "
                                                class="st268" id="XMLID_1305_" />
                                            <polygon style="fill:#006384" points="248.3,94.4 245.9,84.8 250.6,81.5 253.6,88.2 "
                                                class="st268" id="XMLID_1304_" />
                                            <polygon style="fill:#006384"
                                                points="236.8,112.6 226.1,112.9 227,127.3 236.8,127.3 " class="st268"
                                                id="XMLID_1303_" />
                                            <polygon style="fill:#006384"
                                                points="248.2,112.6 259.1,112.9 258.1,127.3 248.2,127.3 " class="st268"
                                                id="XMLID_1302_" />
                                            <polygon style="fill:#003449" points="231.4,116.1 226.1,112.9 236.8,112.6 "
                                                class="st266" id="XMLID_1301_" />
                                            <polygon style="fill:#003449" points="253.9,116.4 248.2,112.6 259.1,112.9 "
                                                class="st266" id="XMLID_1300_" />
                                            <g id="XMLID_1295_">
                                                <circle style="fill:#2b2b2b" r="0.89999998" cy="154.89999" cx="242"
                                                    class="st109" id="XMLID_1299_" />
                                                <circle style="fill:#2b2b2b" r="0.89999998" cy="144.2" cx="241.7" class="st109"
                                                    id="XMLID_1298_" />
                                                <circle style="fill:#2b2b2b" r="0.89999998" cy="133.5" cx="241.5" class="st109"
                                                    id="XMLID_1297_" />
                                                <circle style="fill:#2b2b2b" r="0.89999998" cy="122.8" cx="241.2" class="st109"
                                                    id="XMLID_1296_" />
                                            </g>
                                            <path style="fill:#d29472" inkscape:connector-curvature="0"
                                                d="m 258.9,57.7 c 0.7,-1.5 2.5,-1.6 3.1,-0.3 0.7,1.3 0.3,3.4 -0.7,4.7 -1,1.3 -2.3,1.7 -3.5,1.5"
                                                class="st277" id="XMLID_1294_" />
                                            <path style="fill:#d29472" inkscape:connector-curvature="0"
                                                d="m 246.2,82.9 c -4,0.3 -4.3,-0.4 -5.1,-0.8 -1.2,-0.6 -10.8,-6.1 -11.8,-10.3 -1.7,-7.1 -1.5,-13.5 -1.6,-20.8 -0.1,-5.1 0,-10.7 2.7,-14.7 3.3,-5 9.2,-6 14.5,-6.3 2.5,-0.2 6.4,0.2 9.1,2 2.2,1.4 4.7,7.6 4.7,9.6 0.2,12.3 -0.9,16.1 -2.6,28.3 -0.8,5.5 -8.9,12.9 -9.9,13"
                                                class="st277" id="XMLID_1293_" />
                                            <path style="fill:#bb8062" inkscape:connector-curvature="0"
                                                d="m 243.3,54.4 c 4.1,-7.4 -6.1,-10.2 -7.3,0 0,0 0.8,1.1 3.4,1.1 2.6,0 3.9,-1.1 3.9,-1.1 z"
                                                class="st66" id="XMLID_1292_" />
                                            <path style="fill:#bb8062" inkscape:connector-curvature="0"
                                                d="m 256.7,54.4 c 4.1,-7.4 -6.1,-10.2 -7.3,0 0,0 0.8,10.2 0.8,10.7 0.4,2.6 6.5,-10.7 6.5,-10.7 z"
                                                class="st66" id="XMLID_1291_" />
                                            <path style="fill:#bb8062" inkscape:connector-curvature="0"
                                                d="m 228.2,58.1 c -0.5,-1.8 -2.4,-2.6 -3.8,-1.8 -1.4,0.8 -2.2,2.8 -1.9,4.7 0.2,1.9 1.3,3.5 2.6,4.4 0.8,0.6 1.7,0.9 2.6,0.7 0.9,-0.2 1.7,-1.2 1.7,-2.3"
                                                class="st66" id="XMLID_1290_" />
                                            <g id="XMLID_1288_">
                                                <path style="fill:#56361a" inkscape:connector-curvature="0"
                                                    d="m 249.3,53.6 c 0.2,1.8 0.4,3.6 0.7,5.4 0.2,1.8 0.5,3.6 0.5,5.4 0,0.5 0,0.9 -0.1,1.4 -0.1,0.5 -0.3,0.9 -0.7,1.3 -0.7,0.6 -1.7,0.8 -2.6,0.8 -0.9,0 -1.8,-0.2 -2.7,-0.5 -0.4,-0.2 -0.8,-0.4 -1.2,-0.7 -0.3,-0.3 -0.6,-0.7 -0.6,-1.2 0,0.5 0.3,0.8 0.7,1.1 0.4,0.3 0.8,0.5 1.2,0.6 0.8,0.3 1.7,0.4 2.6,0.4 0.9,0 1.8,-0.2 2.4,-0.8 0.3,-0.3 0.5,-0.7 0.6,-1.1 0.1,-0.4 0,-0.9 0.1,-1.3 0,-1.8 -0.2,-3.6 -0.4,-5.4 l -0.3,-2.7 c -0.1,-0.9 -0.2,-1.8 -0.2,-2.7 z"
                                                    class="st63" id="XMLID_1289_" />
                                            </g>
                                            <path style="fill:#2b2b2b" inkscape:connector-curvature="0"
                                                d="m 236,49.7 c 1.5,-2.4 6.8,-3.3 8.4,-1.1 0.2,0.3 -3.4,-0.8 -8.4,1.1"
                                                class="st109" id="XMLID_1287_" />
                                            <path style="fill:#2b2b2b" inkscape:connector-curvature="0"
                                                d="m 257.1,49.4 c 1.3,1.1 -0.8,-2.7 -3.2,-2.2 -1.3,0.3 -2.6,0.6 -3.2,2.3 0,0.1 3.2,-2.8 6.4,-0.1 z"
                                                class="st109" id="XMLID_1286_" />
                                            <path style="fill:#ffffff" inkscape:connector-curvature="0"
                                                d="m 238.2,72.1 c 1.1,1.1 3.8,2.7 5.6,2.6 1.8,-0.1 3.5,-0.9 4.6,-2.1"
                                                class="st193" id="XMLID_1285_" />
                                            <g id="XMLID_1283_">
                                                <path style="fill:#2b2b2b" inkscape:connector-curvature="0"
                                                    d="m 243.3,54.4 c -0.5,-0.5 -1.1,-0.6 -1.8,-0.7 -0.6,-0.1 -1.2,-0.2 -1.8,-0.2 -0.6,0 -1.2,0.1 -1.8,0.2 -0.6,0.1 -1.2,0.4 -1.9,0.7 0.3,-0.7 0.8,-1.3 1.5,-1.7 0.7,-0.4 1.4,-0.6 2.2,-0.6 0.8,0 1.5,0.2 2.2,0.5 0.3,0.2 0.7,0.4 0.9,0.7 0.3,0.4 0.5,0.8 0.5,1.1 z"
                                                    class="st109" id="XMLID_1284_" />
                                            </g>
                                            <path style="fill:#ffffff" inkscape:connector-curvature="0"
                                                d="m 236.2,54.6 h 6.8 c 0.2,-0.1 0.3,-0.2 0.3,-0.2 -0.5,-1.4 -5,-2.6 -7.3,0 0,0 0.1,0.1 0.2,0.2 z"
                                                class="st193" id="XMLID_1282_" />
                                            <path style="fill:#2b2b2b" inkscape:connector-curvature="0"
                                                d="m 240.9,54.6 c 0.1,-0.2 0.1,-0.4 0.1,-0.6 0,-0.8 -0.7,-1.4 -1.5,-1.4 -0.8,0 -1.5,0.6 -1.5,1.4 0,0.2 0.1,0.4 0.1,0.6 z"
                                                class="st109" id="XMLID_1281_" />
                                            <ellipse style="fill:#ffffff" ry="0.5" rx="0.60000002" cy="53.700001" cx="240.89999"
                                                class="st193" id="XMLID_1280_" />
                                            <g id="XMLID_1278_">
                                                <path style="fill:#2b2b2b" inkscape:connector-curvature="0"
                                                    d="m 256.3,54.4 c -0.5,-0.4 -1,-0.6 -1.5,-0.7 -0.5,-0.1 -1,-0.2 -1.5,-0.2 -0.5,0 -1,0.1 -1.5,0.2 -0.5,0.1 -1,0.4 -1.6,0.7 0.1,-0.6 0.5,-1.2 1.1,-1.6 0.6,-0.4 1.3,-0.6 2,-0.6 0.7,0 1.4,0.2 2,0.6 0.1,0.1 0.3,0.2 0.4,0.3 0.1,0.1 0.2,0.3 0.3,0.4 0.2,0.3 0.4,0.6 0.3,0.9 z"
                                                    class="st109" id="XMLID_1279_" />
                                            </g>
                                            <path style="fill:#ffffff" inkscape:connector-curvature="0"
                                                d="m 250.4,54.6 h 5.7 c 0.1,-0.1 0.2,-0.2 0.2,-0.2 -0.4,-1.4 -4.1,-2.6 -6.1,0 0,0 0.1,0.1 0.2,0.2 z"
                                                class="st193" id="XMLID_1277_" />
                                            <path style="fill:#2b2b2b" inkscape:connector-curvature="0"
                                                d="m 254.3,54.6 c 0.1,-0.2 0.1,-0.4 0.1,-0.6 0,-0.8 -0.6,-1.4 -1.3,-1.4 -0.7,0 -1.3,0.6 -1.3,1.4 0,0.2 0,0.4 0.1,0.6 z"
                                                class="st109" id="XMLID_1276_" />
                                            <ellipse style="fill:#ffffff" ry="0.5" rx="0.60000002" cy="53.700001" cx="254.3"
                                                class="st193" id="XMLID_1275_" />
                                            <path style="fill:#ffffff" inkscape:connector-curvature="0"
                                                d="m 261.9,42.4 c 0,0 -1.7,-14.3 -6.4,-16.6 l -0.6,-2.9 c 0,0 -11.5,-2.6 -22.4,2.4 -10.9,5 -8.4,20.6 -8.4,20.6 z"
                                                class="st193" id="XMLID_1274_" />
                                            <polygon style="fill:#d0d0d0" points="224.4,47.2 262.3,44.4 262.8,41.1 223.7,45 "
                                                class="st274" id="XMLID_1273_" />
                                            <path style="fill:#2b2b2b" inkscape:connector-curvature="0"
                                                d="m 228.3,47 c 0,0 -1.2,30.1 11.8,34.6 0,0 -11.1,-6.2 -8.6,-34.8 z"
                                                class="st109" id="XMLID_1272_" />
                                        </g>
                                    </g>
                                </g>
                                <linearGradient y2="72.440399" x2="304.70209" y1="72.440399" x1="180.8779"
                                    gradientUnits="userSpaceOnUse" id="XMLID_507_">
                                    <stop id="stop144" style="stop-color:#23CAD9" offset="0" />
                                    <stop id="stop146" style="stop-color:#32ADF0" offset="0.9898" />
                                </linearGradient>
        
                                <circle r="59.400002" cy="72.400002" cx="242.8"
                                    style="fill:none;stroke:url(#XMLID_507_);stroke-width:5;stroke-miterlimit:10"
                                    id="XMLID_1264_" />
                            </g>
                            <g id="XMLID_1224_">
                                <rect style="fill:#93adad" height="4.8000002" width="8.3000002" class="st104" y="88.099998"
                                    x="273.29999" id="XMLID_1263_" />
                                <rect style="fill:#f9385d" height="6.3000002" width="20.5" class="st92" y="81.800003"
                                    x="267.20001" id="XMLID_1256_" />
                                <circle style="fill:#23cad9" r="24.700001" cy="116" cx="277.5" class="st72" id="XMLID_1251_" />
                                <circle style="fill:#ffffff" r="18.6" cy="116" cx="277.5" class="st193" id="XMLID_1248_" />
                                <path style="fill:#ff3bcc" inkscape:connector-curvature="0"
                                    d="M 293.7,116 H 277.5 V 99.7 c 8.9,0 16.2,7.3 16.2,16.3 z" class="st158"
                                    id="XMLID_1245_" />
                                <circle style="fill:#042ab2" r="2.3" cy="116" cx="277.5" class="st278" id="XMLID_1236_" />
                                <line style="fill:none;stroke:#042ab2;stroke-width:2;stroke-miterlimit:10" y2="116"
                                    x2="292.29999" y1="116" x1="277.10001" class="st271" id="XMLID_1225_" />
                                <line style="fill:none;stroke:#042ab2;stroke-width:2;stroke-miterlimit:10" y2="116" x2="277.5"
                                    y1="105.1" x1="277.5" class="st271" id="XMLID_621_" />
                            </g>
                        </g>
                    </g>
                    <g id="boton3" inkscape:label="#g1475" @click="evaluar(3)">
                        <g id="XMLID_688_">
                            <rect style="fill:none" height="16.5" width="52" class="st241" y="151.10001" x="385.29999"
                                id="XMLID_1327_" />
                            <text style="font-size:17px;font-family:FontBase-SemiBold;fill:#2d2d2d" id="text163"
                                class="st128 st110 st284" transform="translate(393.7031,163.0947)">IDLH</text>
                        </g>
                        <circle style="fill:#ff7676" r="59.400002" cy="72.400002" cx="411.39999" class="st174"
                            id="XMLID_1342_" />
                        <circle r="59.400002" cy="72.400002" cx="411.39999"
                            style="fill:none;stroke:url(#XMLID_509_);stroke-width:5;stroke-miterlimit:10" id="XMLID_687_" />
                        <g id="XMLID_1326_">
        
                            <linearGradient gradientTransform="matrix(1,0,0,-1,0,-19442.742)" y2="-19544.531" x2="411.3154"
                                y1="-19464.734" x1="411.3154" gradientUnits="userSpaceOnUse" id="XMLID_510_">
                                <stop id="stop173" style="stop-color:#E69D60" offset="0" />
                                <stop id="stop175" style="stop-color:#FFE576" offset="1" />
                            </linearGradient>
                            <polygon style="fill:url(#XMLID_510_)" points="371.3,98.7 451.3,98.7 411.3,27.4 " class="st302"
                                id="XMLID_1336_" />
                            <path style="fill:#353535" inkscape:connector-curvature="0"
                                d="m 453.8,100.2 h -85.1 l 42.5,-75.9 z m -79.9,-3 h 74.8 L 411.3,30.4 Z" class="st257"
                                id="XMLID_1333_" />
                            <g id="XMLID_732_">
                                <path style="fill:#353535" inkscape:connector-curvature="0"
                                    d="m 411.3,90.6 c -1.4,0 -2.5,-0.5 -3.4,-1.4 -0.9,-0.9 -1.4,-2.1 -1.4,-3.5 0,-1.4 0.5,-2.6 1.4,-3.5 0.9,-0.9 2,-1.4 3.4,-1.4 1.4,0 2.5,0.5 3.4,1.4 0.9,0.9 1.4,2.1 1.4,3.5 0,1.4 -0.5,2.6 -1.4,3.5 -0.9,0.9 -2,1.4 -3.4,1.4 z m -2.5,-12.9 -1.1,-16.3 -0.3,-7.1 h 7.9 l -0.3,7.1 -1.1,16.3 z"
                                    class="st257" id="XMLID_733_" />
                            </g>
                        </g>
                    </g>
                    <g id="check1" inkscape:label="#g1058" :class="visto1 ?'mostrar':'esconder'">
                        <path
                            d="m 120.59869,35.240594 c -6.7,0 -12.1,-5.4 -12.1,-12.1 0,-6.7 5.4,-12.1 12.1,-12.1 6.7,0 12.1,5.4 12.1,12.1 0,6.7 -5.4,12.1 -12.1,12.1 z"
                            id="XMLID_115_" inkscape:connector-curvature="0" style="fill:url(#XMLID_423_)" />
                        <path d="m 118.69869,30.040594 -4.9,-4.6 2.2,-2.5 2.5,2.3 6.5,-7.7 2.6,2.2 z" id="XMLID_165_"
                            inkscape:connector-curvature="0" style="fill:#ffffff" />
                    </g>
                    <g id="check2" inkscape:label="#g1073" :class="visto2 ?'mostrar':'esconder'">
                        <path
                            d="m 289.67724,35.240594 c -6.7,0 -12.1,-5.4 -12.1,-12.1 0,-6.7 5.4,-12.1 12.1,-12.1 6.7,0 12.1,5.4 12.1,12.1 0,6.7 -5.4,12.1 -12.1,12.1 z"
                            id="XMLID_115_-2" inkscape:connector-curvature="0" style="fill:url(#XMLID_423_-3)" />
                        <path d="m 287.77724,30.040594 -4.9,-4.6 2.2,-2.5 2.5,2.3 6.5,-7.7 2.6,2.2 z" id="XMLID_165_-9"
                            inkscape:connector-curvature="0" style="fill:#ffffff" />
                    </g>
                    <g id="check3" inkscape:label="#g1088" :class="visto3 ?'mostrar':'esconder'">
                        <path
                            d="m 460.35843,35.240594 c -6.7,0 -12.1,-5.4 -12.1,-12.1 0,-6.7 5.4,-12.1 12.1,-12.1 6.7,0 12.1,5.4 12.1,12.1 0,6.7 -5.4,12.1 -12.1,12.1 z"
                            id="XMLID_115_-6" inkscape:connector-curvature="0" style="fill:url(#XMLID_423_-1)" />
                        <path d="m 458.45843,30.040594 -4.9,-4.6 2.2,-2.5 2.5,2.3 6.5,-7.7 2.6,2.2 z" id="XMLID_165_-1"
                            inkscape:connector-curvature="0" style="fill:#ffffff" />
                    </g>
                </svg>
        <modal-app v-model="modala" :fullscreen="false" width="700px">
            <template slot="modaltittle">
</template>

<template slot="modalcontent">
    <v-layout row wrap justify-center align-center>
        <v-flex xs12>
            <h2>TWA</h2>
            <p>TLV-TWA (Threshold Limit Value – Time Weighted Average) Concentración promedio, durante 8 horas diarias o 40 horas semanales, a la cual se cree que casi todos los trabajadores pueden ser repetidamente expuestos día tras día, durante su vida laboral,
                sin ningún impacto en la salud. 
                <!-- <br><br> Para mayor información, haz clic en el botón para reproducir el video. -->
            </p>
            <!-- <p class="text-xs-center" v-if="modala">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/CdTiA6v3eyQ" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </p> -->
        </v-flex>
    </v-layout>
</template>
        </modal-app>
        <modal-app v-model="modalb" :fullscreen="false" width="700px">
<template slot="modaltittle">
    
</template>

<template slot="modalcontent">
    <v-layout row wrap justify-center align-center>
        <v-flex xs12>
            <h2>STEL</h2>
            <p>TLV-STEL (Short Term Exposure Limit). Concentración promedio durante 15 minutos que no debe ser excedida en ningún momento durante un día de trabajo, aún si el promedio de 8 horas está dentro del TLV-TWA. Exposiciones superiores al valor TWA y
                hasta el STEL deberán ser menores de 15 minutos, no deberían ocurrir más de 4 veces por día y debería haber un intervalo de al menos 1 hora entre exposiciones sucesivas.</p>
        </v-flex>
    </v-layout>
</template>
        </modal-app>
        <modal-app v-model="modalc" :fullscreen="false" width="700px">
<template slot="modaltittle">
    
</template>

<template slot="modalcontent">
    <v-layout row wrap justify-center align-center>
        <v-flex xs12>
            <h2>IDLH</h2>
            <p>IDLH de NIOSH (Inmediately Dangerous to Life or Health). Concentración máxima a la cual existe un peligro inmediato para la vida de cualquier persona (puede generar daños irreversibles o de largo plazo en su salud, y puede impedirle tomar acciones
                protectoras o de escape en atmósferas peligrosas).</p>
        </v-flex>
    </v-layout>
</template>
        </modal-app>
    </div>
</template>

<script>
import nextConditions from "../../../js/mixins/nextConditions";
export default {
    mixins: [nextConditions],
    // props: {
    //     modala: {
    //         type: Boolean,
    //         default: false
    //     },
    // },
    data() {
        return {
            visto1: false,
            visto2: false,
            visto3: false,
            modala: false,
            modalb: false,
            modalc: false,
        }
    },
    methods: {
        evaluar(option) {
            if (option == 1) {
                this.visto1 = true;
                this.modala = true;
            }
            if (option == 2) {
                this.visto2 = true;
                this.modalb = true;
            }
            if (option == 3) {
                this.visto3 = true;
                this.modalc = true;
            }
            if (this.visto1 && this.visto2 && this.visto3) {
                setTimeout(() => {
                    this.$store.commit('nextShow', true)
                }, 6000);
            }
        }
    },
    mounted() {},
}
</script>


<style lang="scss" scoped>
svg {
    cursor: pointer;
}

.mostrar {
    display: block;
}

.esconder {
    display: none;
}

.st0 {
    fill: none;
    stroke: url(#XMLID_2661_);
    stroke-width: 6;
    stroke-miterlimit: 10;
}

.st1 {
    fill: #46535B;
}

.st2 {
    fill: #ABBFC6;
}

.st3 {
    fill: #AC7B63;
}

.st4 {
    fill: #105477;
}

.st5 {
    fill: #106489;
}

.st6 {
    fill: none;
    stroke: #23CAD9;
    stroke-width: 0.5;
    stroke-miterlimit: 10;
}

.st7 {
    fill: url(#XMLID_2624_);
    stroke: #383838;
    stroke-miterlimit: 10;
}

.st8 {
    fill: #E0B192;
}

.st9 {
    fill: #E0E2DE;
}

.st10 {
    fill: none;
    stroke: url(#XMLID_2481_);
    stroke-width: 2;
    stroke-miterlimit: 10;
}

.st11 {
    fill: none;
    stroke: url(#XMLID_2482_);
    stroke-width: 2;
    stroke-miterlimit: 10;
}

.st12 {
    fill: none;
    stroke: url(#XMLID_2483_);
    stroke-width: 2;
    stroke-miterlimit: 10;
}

.st13 {
    fill: none;
    stroke: #353535;
    stroke-width: 2;
    stroke-miterlimit: 10;
}

.st14 {
    fill: #132C33;
}

.st15 {
    fill: #E1E1E1;
}

.st16 {
    fill: none;
    stroke: url(#XMLID_2674_);
    stroke-width: 6;
    stroke-miterlimit: 10;
}

.st17 {
    fill: #32ADF0;
    stroke: #32ADF0;
    stroke-width: 11;
    stroke-miterlimit: 10;
}

.st18 {
    fill: url(#XMLID_2426_);
    stroke: #383838;
    stroke-miterlimit: 10;
}

.st19 {
    fill: url(#XMLID_2448_);
    stroke: #232323;
    stroke-miterlimit: 10;
}

.st20 {
    fill: none;
    stroke: #1D1D1B;
    stroke-miterlimit: 10;
}

.st21 {
    clip-path: url(#XMLID_509_);
}

.st22 {
    clip-path: url(#XMLID_3056_);
}

.st23 {
    fill: #4C4C4C;
}

.st24 {
    fill: #E89C2E;
}

.st25 {
    fill: #E8B897;
}

.st26 {
    filter: url(#Adobe_OpacityMaskFilter);
}

.st27 {
    fill: none;
    stroke: url(#XMLID_2684_);
    stroke-width: 6;
    stroke-miterlimit: 10;
}

.st28 {
    fill: none;
    stroke: url(#XMLID_2685_);
    stroke-width: 6;
    stroke-miterlimit: 10;
}

.st29 {
    fill: #B0D882;
}

.st30 {
    fill: none;
    stroke: url(#XMLID_2688_);
    stroke-width: 6;
    stroke-miterlimit: 10;
}

.st31 {
    fill: url(#XMLID_2432_);
    stroke: #383838;
    stroke-miterlimit: 10;
}

.st32 {
    fill: url(#XMLID_2435_);
    stroke: #383838;
    stroke-miterlimit: 10;
}

.st33 {
    fill: none;
    stroke: url(#XMLID_2866_);
    stroke-width: 5;
    stroke-miterlimit: 10;
}

.st34 {
    fill: #B4754D;
}

.st35 {
    fill: #28F7D1;
    stroke: #23CAD9;
    stroke-width: 0.5;
    stroke-miterlimit: 10;
}

.st36 {
    fill: #B4B4B4;
}

.st37 {
    fill: #B50D3D;
}

.st38 {
    opacity: 0.17;
    fill: #1D1D1B;
}

.st39 {
    fill: #B5B5B5;
}

.st40 {
    fill: none;
    stroke: #32ADF0;
    stroke-width: 2;
    stroke-miterlimit: 10;
    stroke-dasharray: 9.0305, 5.644;
}

.st41 {
    fill: #B7B7B7;
}

.st42 {
    fill: #1D1D1B;
}

.st43 {
    fill: #B8BAB5;
}

.st44 {
    fill: #EDEDED;
}

.st45 {
    fill: #505154;
}

.st46 {
    fill: none;
    stroke: url(#XMLID_3050_);
    stroke-width: 4;
    stroke-miterlimit: 10;
}

.st47 {
    fill: url(#XMLID_2445_);
    stroke: #383838;
    stroke-miterlimit: 10;
}

.st48 {
    fill: #513B1E;
}

.st49 {
    fill: #EF5A24;
}

.st50 {
    fill: #EF8425;
}

.st51 {
    fill: none;
    stroke: #969696;
    stroke-miterlimit: 10;
}

.st52 {
    fill: url(#XMLID_2502_);
    stroke: #232323;
    stroke-miterlimit: 10;
}

.st53 {
    fill: url(#XMLID_1731_);
}

.st54 {
    fill: #544733;
}

.st55 {
    fill: none;
    stroke: #FFFFFF;
    stroke-miterlimit: 10;
}

.st56 {
    fill: none;
    stroke: url(#XMLID_2055_);
    stroke-width: 5;
    stroke-miterlimit: 10;
}

.st57 {
    fill: none;
    stroke: url(#XMLID_2056_);
    stroke-width: 5;
    stroke-miterlimit: 10;
}

.st58 {
    fill: #54D354;
}

.st59 {
    fill: #555555;
}

.st60 {
    fill: #555D60;
}

.st61 {
    fill: none;
    stroke: url(#XMLID_2647_);
    stroke-width: 4;
    stroke-miterlimit: 10;
}

.st62 {
    fill: none;
    stroke: url(#XMLID_2648_);
    stroke-width: 4;
    stroke-miterlimit: 10;
}

.st63 {
    fill: #56361A;
}

.st64 {
    fill: #BAC8D1;
}

.st65 {
    fill: #F9385D;
    stroke: #23CAD9;
    stroke-width: 0.5;
    stroke-miterlimit: 10;
}

.st66 {
    fill: #BB8062;
}

.st67 {
    fill: #C7EE95;
    stroke: #23CAD9;
    stroke-width: 0.5;
    stroke-miterlimit: 10;
}

.st68 {
    fill: none;
    stroke: url(#XMLID_2063_);
    stroke-width: 5;
    stroke-miterlimit: 10;
}

.st69 {
    fill: none;
    stroke: url(#XMLID_2065_);
    stroke-width: 5;
    stroke-miterlimit: 10;
}

.st70 {
    opacity: 0.58;
    fill: #FFFFFF;
}

.st71 {
    fill: #2368D9;
}

.st72 {
    fill: #23CAD9;
}

.st73 {
    fill: none;
    stroke: url(#XMLID_2689_);
    stroke-width: 5;
    stroke-miterlimit: 10;
}

.st74 {
    fill: #F4C4A4;
}

.st75 {
    fill: none;
    stroke: url(#XMLID_2867_);
    stroke-width: 4;
    stroke-miterlimit: 10;
}

.st76 {
    opacity: 0.4;
    fill: #1D1D1B;
}

.st77 {
    fill: none;
    stroke: url(#XMLID_2728_);
    stroke-width: 5;
    stroke-miterlimit: 10;
}

.st78 {
    fill: url(#XMLID_2522_);
    stroke: #232323;
    stroke-miterlimit: 10;
}

.st79 {
    fill: url(#XMLID_2501_);
    stroke: #383838;
    stroke-miterlimit: 10;
}

.st80 {
    fill: none;
    stroke: url(#XMLID_2485_);
    stroke-width: 5;
    stroke-miterlimit: 10;
}

.st81 {
    fill: #28F7D1;
}

.st82 {
    fill: none;
    stroke: url(#XMLID_2487_);
    stroke-width: 5;
    stroke-miterlimit: 10;
}

.st83 {
    fill: none;
    stroke: #32ADF0;
    stroke-width: 2;
    stroke-miterlimit: 10;
    stroke-dasharray: 8.5477, 5.3423;
}

.st84 {
    fill: none;
    stroke: url(#XMLID_2488_);
    stroke-width: 5;
    stroke-miterlimit: 10;
}

.st85 {
    fill: #F7F7F7;
}

.st86 {
    fill: #F7F8F9;
}

.st87 {
    fill: url(#XMLID_2505_);
    stroke: #383838;
    stroke-miterlimit: 10;
}

.st88 {
    fill: url(#XMLID_2506_);
    stroke: #383838;
    stroke-miterlimit: 10;
}

.st89 {
    fill: none;
    stroke: #32ADF0;
    stroke-width: 2;
    stroke-miterlimit: 10;
    stroke-dasharray: 7.6408, 4.7755;
}

.st90 {
    fill: #5E5E5E;
}

.st91 {
    fill: none;
    stroke: url(#XMLID_2690_);
    stroke-width: 5;
    stroke-miterlimit: 10;
}

.st92 {
    fill: #F9385D;
}

.st93 {
    opacity: 0.35;
    fill: #9FEDFF;
}

.st94 {
    fill: none;
    stroke: url(#XMLID_2554_);
    stroke-width: 6;
    stroke-miterlimit: 10;
}

.st95 {
    fill: none;
    stroke: url(#XMLID_2697_);
    stroke-width: 5;
    stroke-miterlimit: 10;
}

.st96 {
    fill: none;
    stroke: url(#XMLID_2254_);
    stroke-width: 4;
    stroke-miterlimit: 10;
}

.st97 {
    fill: none;
    stroke: url(#XMLID_2698_);
    stroke-width: 5;
    stroke-miterlimit: 10;
}

.st98 {
    fill: #C07E61;
}

.st99 {
    fill: #C12F52;
}

.st100 {
    fill: none;
    stroke: #32ADF0;
    stroke-width: 2;
    stroke-miterlimit: 10;
    stroke-dasharray: 7.8706, 4.9191;
}

.st101 {
    fill: #C1A880;
}

.st102 {
    fill: url(#XMLID_2474_);
    stroke: #383838;
    stroke-miterlimit: 10;
}

.st103 {
    fill: #939FA3;
}

.st104 {
    fill: #93ADAD;
}

.st105 {
    fill: url(#XMLID_2479_);
    stroke: #383838;
    stroke-miterlimit: 10;
}

.st106 {
    fill: #943B8A;
}

.st107 {
    fill: #C3CDDD;
}

.st108 {
    fill: #C54EB9;
}

.st109 {
    fill: #2B2B2B;
}

.st110 {
    font-family: 'FontBase-SemiBold';
}

.st111 {
    fill: url(#XMLID_2057_);
}

.st112 {
    fill: url(#XMLID_2061_);
}

.st113 {
    fill: url(#XMLID_2064_);
}

.st114 {
    fill: url(#XMLID_2067_);
}

.st115 {
    fill: url(#XMLID_2068_);
}

.st116 {
    fill: url(#XMLID_2069_);
}

.st117 {
    fill: url(#XMLID_2127_);
}

.st118 {
    fill: url(#XMLID_2131_);
}

.st119 {
    fill: url(#XMLID_2132_);
}

.st120 {
    fill: url(#XMLID_2140_);
}

.st121 {
    fill: url(#XMLID_2141_);
}

.st122 {
    fill: url(#XMLID_2144_);
}

.st123 {
    fill: url(#XMLID_2146_);
}

.st124 {
    fill: url(#XMLID_2147_);
}

.st125 {
    fill: url(#XMLID_2150_);
}

.st126 {
    fill: #C7EE95;
}

.st127 {
    fill: #C7F2E9;
}

.st128 {
    fill: #2D2D2D;
}

.st129 {
    fill: none;
    stroke: #042AB2;
    stroke-width: 3;
    stroke-miterlimit: 10;
}

.st130 {
    fill: url(#XMLID_2238_);
}

.st131 {
    fill: #99845F;
}

.st132 {
    fill: url(#XMLID_2248_);
}

.st133 {
    fill: url(#XMLID_2249_);
}

.st134 {
    fill: url(#XMLID_2253_);
}

.st135 {
    fill: none;
    stroke: #28F7D1;
    stroke-width: 2;
    stroke-miterlimit: 10;
}

.st136 {
    fill: url(#XMLID_2355_);
}

.st137 {
    fill: url(#XMLID_2358_);
}

.st138 {
    fill: url(#XMLID_2359_);
}

.st139 {
    fill: url(#XMLID_2374_);
}

.st140 {
    fill: url(#XMLID_2375_);
}

.st141 {
    fill: url(#XMLID_2425_);
}

.st142 {
    fill: url(#XMLID_2430_);
}

.st143 {
    fill: url(#XMLID_2431_);
}

.st144 {
    fill: url(#XMLID_2436_);
}

.st145 {
    fill: url(#XMLID_2440_);
}

.st146 {
    fill: url(#XMLID_2441_);
}

.st147 {
    fill: url(#XMLID_2442_);
}

.st148 {
    fill: url(#XMLID_2443_);
}

.st149 {
    fill: url(#XMLID_2444_);
}

.st150 {
    fill: url(#XMLID_2449_);
}

.st151 {
    fill: url(#XMLID_2473_);
}

.st152 {
    fill: url(#XMLID_2480_);
}

.st153 {
    fill: url(#XMLID_2489_);
}

.st154 {
    fill: url(#XMLID_2490_);
}

.st155 {
    fill: url(#XMLID_2491_);
}

.st156 {
    fill: url(#XMLID_2493_);
}

.st157 {
    fill: url(#XMLID_2496_);
}

.st158 {
    fill: #FF3BCC;
}

.st159 {
    fill: url(#XMLID_2500_);
}

.st160 {
    fill: url(#XMLID_2503_);
}

.st161 {
    fill: url(#XMLID_2504_);
}

.st162 {
    fill: url(#XMLID_2507_);
}

.st163 {
    fill: url(#XMLID_2508_);
}

.st164 {
    fill: url(#XMLID_2509_);
}

.st165 {
    fill: url(#XMLID_2510_);
}

.st166 {
    fill: url(#XMLID_2511_);
}

.st167 {
    fill: url(#XMLID_2512_);
}

.st168 {
    fill: url(#XMLID_2523_);
}

.st169 {
    fill: url(#XMLID_2524_);
}

.st170 {
    fill: url(#XMLID_2535_);
}

.st171 {
    fill: url(#XMLID_2536_);
}

.st172 {
    fill: url(#XMLID_2537_);
}

.st173 {
    fill: url(#XMLID_2539_);
}

.st174 {
    fill: #FF7676;
}

.st175 {
    fill: url(#XMLID_2540_);
}

.st176 {
    fill: url(#XMLID_2541_);
}

.st177 {
    fill: url(#XMLID_2544_);
}

.st178 {
    fill: url(#XMLID_2545_);
}

.st179 {
    fill: #FF88A4;
}

.st180 {
    fill: url(#XMLID_2553_);
}

.st181 {
    fill: url(#XMLID_2563_);
}

.st182 {
    fill: url(#XMLID_2582_);
}

.st183 {
    fill: url(#XMLID_2585_);
}

.st184 {
    fill: url(#XMLID_2591_);
}

.st185 {
    fill: url(#XMLID_2597_);
}

.st186 {
    fill: #FFAF50;
}

.st187 {
    fill: #FFB236;
}

.st188 {
    fill: #FFC555;
}

.st189 {
    fill: #FFC892;
}

.st190 {
    fill: #FFD773;
}

.st191 {
    fill: #FFEB99;
}

.st192 {
    fill: #FFFF00;
}

.st193 {
    fill: #FFFFFF;
}

.st194 {
    fill: url(#XMLID_2601_);
}

.st195 {
    fill: url(#XMLID_2608_);
}

.st196 {
    fill: url(#XMLID_2610_);
}

.st197 {
    fill: url(#XMLID_2521_);
    stroke: #383838;
    stroke-miterlimit: 10;
}

.st198 {
    fill: url(#XMLID_2625_);
}

.st199 {
    fill: url(#XMLID_2627_);
}

.st200 {
    fill: url(#XMLID_2629_);
}

.st201 {
    fill: url(#XMLID_2543_);
    stroke: #232323;
    stroke-miterlimit: 10;
}

.st202 {
    fill: url(#XMLID_2630_);
}

.st203 {
    fill: url(#XMLID_2632_);
}

.st204 {
    fill: url(#XMLID_2639_);
}

.st205 {
    fill: url(#XMLID_2640_);
}

.st206 {
    fill: url(#XMLID_2641_);
}

.st207 {
    fill: url(#XMLID_2644_);
}

.st208 {
    fill: url(#XMLID_2649_);
}

.st209 {
    fill: url(#XMLID_2656_);
}

.st210 {
    fill: url(#XMLID_2658_);
}

.st211 {
    fill: url(#XMLID_2676_);
}

.st212 {
    fill: url(#XMLID_2678_);
}

.st213 {
    fill: url(#XMLID_2679_);
}

.st214 {
    fill: url(#XMLID_2680_);
}

.st215 {
    fill: url(#XMLID_2686_);
}

.st216 {
    fill: url(#XMLID_2687_);
}

.st217 {
    fill: url(#XMLID_2691_);
}

.st218 {
    fill: url(#XMLID_2692_);
}

.st219 {
    fill: none;
    stroke: #F9385D;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-miterlimit: 10;
}

.st220 {
    fill: none;
    stroke: #F9385D;
    stroke-width: 3;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-miterlimit: 10;
}

.st221 {
    fill: url(#XMLID_2700_);
}

.st222 {
    fill: url(#XMLID_2525_);
    stroke: #383838;
    stroke-miterlimit: 10;
}

.st223 {
    fill: url(#XMLID_2735_);
}

.st224 {
    fill: url(#XMLID_2766_);
}

.st225 {
    fill: url(#XMLID_2779_);
}

.st226 {
    fill: url(#XMLID_2805_);
}

.st227 {
    fill: url(#XMLID_2825_);
}

.st228 {
    fill: url(#XMLID_2860_);
}

.st229 {
    fill: url(#XMLID_2861_);
}

.st230 {
    fill: url(#XMLID_2863_);
}

.st231 {
    fill: url(#XMLID_2864_);
}

.st232 {
    fill: url(#XMLID_2869_);
}

.st233 {
    fill: url(#XMLID_2870_);
}

.st234 {
    fill: url(#XMLID_2871_);
}

.st235 {
    fill: url(#XMLID_2875_);
}

.st236 {
    fill: url(#XMLID_2883_);
}

.st237 {
    fill: url(#XMLID_2890_);
}

.st238 {
    fill: url(#XMLID_2891_);
}

.st239 {
    fill: url(#XMLID_2892_);
}

.st240 {
    fill: url(#XMLID_2899_);
}

.st241 {
    fill: none;
}

.st242 {
    fill: url(#XMLID_2907_);
}

.st243 {
    fill: url(#XMLID_2968_);
}

.st244 {
    fill: #666461;
}

.st245 {
    fill: #9A5F3E;
}

.st246 {
    fill: #9BC16B;
}

.st247 {
    fill: #68696D;
}

.st248 {
    fill: #CCCCCC;
}

.st249 {
    fill: #CCD8E2;
}

.st250 {
    fill: #303233;
}

.st251 {
    fill: none;
    stroke: #32ADF0;
    stroke-width: 2;
    stroke-miterlimit: 10;
    stroke-dasharray: 7.8702, 4.9189;
}

.st252 {
    fill: url(#XMLID_2534_);
    stroke: #383838;
    stroke-miterlimit: 10;
}

.st253 {
    fill: none;
    stroke: url(#XMLID_2357_);
    stroke-miterlimit: 10;
}

.st254 {
    fill: #28F7D1;
    stroke: #042AB2;
    stroke-width: 3;
    stroke-miterlimit: 10;
}

.st255 {
    fill: #32ADF0;
}

.st256 {
    fill: none;
    stroke: #BCBCBC;
    stroke-miterlimit: 10;
}

.st257 {
    fill: #353535;
}

.st258 {
    fill: #353638;
}

.st259 {
    fill: none;
    stroke: url(#XMLID_2437_);
    stroke-width: 2;
    stroke-miterlimit: 10;
}

.st260 {
    fill: none;
    stroke: url(#XMLID_2438_);
    stroke-width: 2;
    stroke-miterlimit: 10;
}

.st261 {
    fill: none;
    stroke: url(#XMLID_2439_);
    stroke-width: 2;
    stroke-miterlimit: 10;
}

.st262 {
    fill: none;
    stroke: url(#XMLID_2626_);
    stroke-width: 6;
    stroke-miterlimit: 10;
}

.st263 {
    fill: none;
    stroke: url(#XMLID_2628_);
    stroke-width: 6;
    stroke-miterlimit: 10;
}

.st264 {
    fill: url(#XMLID_2542_);
    stroke: #383838;
    stroke-miterlimit: 10;
}

.st265 {
    fill: url(#XMLID_2546_);
    stroke: #383838;
    stroke-miterlimit: 10;
}

.st266 {
    fill: #003449;
}

.st267 {
    fill: #004263;
}

.st268 {
    fill: #006384;
}

.st269 {
    fill: #006937;
}

.st270 {
    fill: #008FB6;
}

.st271 {
    fill: none;
    stroke: #042AB2;
    stroke-width: 2;
    stroke-miterlimit: 10;
}

.st272 {
    fill: url(#XMLID_2606_);
    stroke: #232323;
    stroke-miterlimit: 10;
}

.st273 {
    fill: #020202;
}

.st274 {
    fill: #D0D0D0;
}

.st275 {
    fill: none;
    stroke: #2368D9;
    stroke-width: 3;
    stroke-miterlimit: 10;
}

.st276 {
    fill: none;
    stroke: url(#XMLID_2771_);
    stroke-width: 5;
    stroke-miterlimit: 10;
}

.st277 {
    fill: #D29472;
}

.st278 {
    fill: #042AB2;
}

.st279 {
    fill: none;
    stroke: url(#XMLID_2634_);
    stroke-width: 6;
    stroke-miterlimit: 10;
}

.st280 {
    fill: none;
    stroke: url(#XMLID_2635_);
    stroke-width: 6;
    stroke-miterlimit: 10;
}

.st281 {
    fill: url(#XMLID_2551_);
    stroke: #383838;
    stroke-miterlimit: 10;
}

.st282 {
    fill: none;
    stroke: #32ADF0;
    stroke-width: 2;
    stroke-miterlimit: 10;
    stroke-dasharray: 8.7526, 5.4704;
}

.st283 {
    fill: #3A2914;
}

.st284 {
    font-size: 17;
}

.st285 {
    fill: url(#XMLID_3022_);
}

.st286 {
    fill: url(#XMLID_3024_);
}

.st287 {
    fill: url(#XMLID_3039_);
}

.st288 {
    fill: url(#XMLID_3040_);
}

.st289 {
    fill: url(#XMLID_3042_);
}

.st290 {
    fill: url(#XMLID_3043_);
}

.st291 {
    fill: url(#XMLID_3045_);
}

.st292 {
    fill: url(#XMLID_3046_);
}

.st293 {
    fill: url(#XMLID_3048_);
}

.st294 {
    fill: url(#XMLID_3049_);
}

.st295 {
    fill: url(#XMLID_3055_);
}

.st296 {
    fill: none;
    stroke: #686868;
    stroke-miterlimit: 10;
}

.st297 {
    fill: url(#XMLID_463_);
}

.st298 {
    fill: url(#XMLID_464_);
}

.st299 {
    fill: url(#XMLID_496_);
}

.st300 {
    fill: #3D3D3D;
}

.st301 {
    fill: url(#XMLID_507_);
}

.st302 {
    fill: url(#XMLID_510_);
}

.st303 {
    fill: url(#XMLID_512_);
}

.st304 {
    fill: url(#XMLID_514_);
}

.st305 {
    fill: #D82A53;
}

.st306 {
    mask: url(#XMLID_2134_);
}

.st307 {
    mask: url(#XMLID_2143_);
}

.st308 {
    mask: url(#XMLID_2149_);
}

.st309 {
    mask: url(#XMLID_2240_);
}

.st310 {
    fill: none;
    stroke: #32ADF0;
    stroke-width: 2;
    stroke-miterlimit: 10;
    stroke-dasharray: 7.289, 4.5557;
}

.st311 {
    fill: #707070;
}

.st312 {
    clip-path: url(#XMLID_2484_);
}

.st313 {
    clip-path: url(#XMLID_2486_);
}

.st314 {
    fill: none;
    stroke: url(#XMLID_2643_);
    stroke-width: 6;
    stroke-miterlimit: 10;
}

.st315 {
    fill: none;
    stroke: url(#XMLID_2646_);
    stroke-width: 6;
    stroke-miterlimit: 10;
}

.st316 {
    clip-path: url(#XMLID_2642_);
}

.st317 {
    clip-path: url(#XMLID_2645_);
}

.st318 {
    clip-path: url(#XMLID_2677_);
}

.st319 {
    fill: #A2A599;
}

.st320 {
    fill: #A2A7AC;
}

.st321 {
    fill: none;
    stroke: #28F7D1;
    stroke-miterlimit: 10;
}

.st322 {
    fill: #A4704C;
}

.st323 {
    clip-path: url(#XMLID_2905_);
}

.st324 {
    fill: none;
    stroke: #32ADF0;
    stroke-width: 2;
    stroke-miterlimit: 10;
    stroke-dasharray: 8.339, 5.2119;
}

.st325 {
    fill: url(#XMLID_2603_);
    stroke: #383838;
    stroke-miterlimit: 10;
}

.st326 {
    fill: #DA9571;
}

.st327 {
    fill: #DB6812;
}

.st328 {
    fill: #0D1F30;
}

.st329 {
    fill: none;
    stroke: #545454;
    stroke-width: 3;
    stroke-miterlimit: 10;
}

.st330 {
    fill: #A8A8A8;
}

.st331 {
    fill: #DCFFF8;
}

.st332 {
    fill: none;
    stroke: #23CAD9;
    stroke-miterlimit: 10;
}

.st333 {
    fill: #0F0F0F;
}

.st334 {
    fill: #0F4B63;
}

.st335 {
    fill: #DDE5ED;
}

.st336 {
    fill: url(#XMLID_2427_);
    stroke: #232323;
    stroke-miterlimit: 10;
}

.st337 {
    fill: #424242;
}

.st338 {
    fill: none;
    stroke: #32ADF0;
    stroke-width: 2;
    stroke-miterlimit: 10;
}

.st339 {
    filter: url(#Adobe_OpacityMaskFilter_1_);
}

.st340 {
    filter: url(#Adobe_OpacityMaskFilter_2_);
}

.st341 {
    filter: url(#Adobe_OpacityMaskFilter_3_);
}

.st342 {
    fill: url(#XMLID_2614_);
    stroke: #383838;
    stroke-miterlimit: 10;
}

.st343 {
    opacity: 0.51;
    fill: #FFFFFF;
    enable-background: new;
}

.st344 {
    fill: #444444;
}

.st345 {
    fill: none;
    stroke: url(#XMLID_2356_);
    stroke-miterlimit: 10;
}
</style>